export const CLABE_HELP_URL =
  'https://help.taxdown.com.mx/es/articles/8896522-como-obtengo-mi-cuenta-clabe';
export const PREVIOUS_YEARS_HELP_URL =
  'https://help.taxdown.com.mx/es/articles/7211504-en-que-consiste-la-revision-de-anos-anteriores';
export const DISCARDED_HELP_URL =
  'https://help.taxdown.com.mx/es/articles/7211503-que-casos-no-podemos-tratar-desde-taxdown-este-ano';
export const PASSWORD_SAT_HELP_URL =
  'https://help.taxdown.com.mx/es/articles/7157712-que-es-la-contrasena-del-sat-y-como-la-genero';
export const RESULT_MANDATORY_HELP_URL =
  'https://help.taxdown.com.mx/es/articles/7245891-que-pasa-si-no-declaro-y-estoy-obligado-a';
export const RESULT_NOT_MANDATORY_HELP_URL =
  'https://help.taxdown.com.mx/es/articles/7245872-estoy-obligado-a-presentar-la-declaracion';
export const REFERRAL_TERMS_AND_CONDITIONS_URL =
  'https://help.taxdown.com.mx/es/articles/8042781-terminos-y-condiciones-de-invita-a-tus-amigos';
export const RFC_HELP_URL = 'https://intercom.help/taxdownmexico/es/articles/6563340-que-es-el-rfc';

export const INSTALLMENTS_HELP_URL =
  'https://help.taxdown.com.mx/es/articles/8938197-como-funciona-el-pago-por-parcialidades-del-sat';

export const NOT_SUCCESS_LINK =
  'https://help.taxdown.com.mx/es/articles/10007385-por-que-el-sat-ha-rechazado-mi-devolucion-anual';

export const PAYMENT_INFO_URL =
  'https://help.taxdown.com.mx/es/articles/10136242-como-encuentro-mi-pago';

export const WHY_THIS_INFORMATION_URL =
  'https://help.taxdown.com.mx/es/articles/10542112-por-que-te-pedimos-esta-informacion';
export const NO_RFC_URL =
  'https://help.taxdown.com.mx/es/articles/7176404-no-tengo-rfc-como-lo-consigo';
export const NO_REMEMBER_RFC_URL =
  'https://help.taxdown.com.mx/es/articles/6563407-no-recuerdo-mi-rfc-donde-lo-consulto';
export const NO_PASSWORD_URL =
  'https://help.taxdown.com.mx/es/articles/7176406-no-tengo-contrasena-como-la-genero';
export const FILED_REINTENTS_HELP_URL =
  'https://help.taxdown.com.mx/es/articles/10007385-que-pasa-con-mi-devolucion-del-sat';
export const WHAT_IS_EFIRMA_URL =
  'https://help.taxdown.com.mx/es/articles/7176350-que-es-la-e-firma';

export const INVALID_SAT_CLABE_URL =
  'https://help.taxdown.com.mx/es/articles/11662432-no-tienes-cuenta-en-un-banco-autorizado';
